<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-file-input
              v-model="files.icon"
              :loading="loading"
              accept="image/png, image/jpg, image/jpeg"
              dense
              :label="$t('select_logo')"
              class="contentinfo"
              outlined
              show-size
              @change="readerRead($event, 'logo')"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-files-logo`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('select_logo')"
            />
          </div>
          <div v-if="!!files.icon" class="d-flex align-start" style="gap: 8px">
            <div>
              <h3>{{ $t("logo_144px") }}</h3>
              <canvas id="canvas144"></canvas>
            </div>

            <div>
              <h3>{{ $t("logo_48px") }}</h3>
              <canvas id="canvas48"></canvas>
            </div>
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-file-input
              v-model="files.screenshot"
              :loading="loading"
              accept="image/png, image/jpg, image/jpeg"
              dense
              :label="$t('select_photo')"
              outlined
              show-size
              @change="readerRead($event, 'screenshot')"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-files-screenshot`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('select_photo')"
            />
          </div>
          <div
            v-if="files.screenshot"
            class="d-flex align-start flex-wrap"
            style="gap: 8px"
          >
            <div>
              <h3>{{ $t("photo_wide") }}</h3>
              <canvas id="screenshotWide"></canvas>
            </div>

            <div>
              <h3>{{ $t("photo") }}</h3>
              <canvas id="screenshot600"></canvas>
            </div>
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import {
  base64ToBlob,
  drawImageOnCanvasCover,
  saveOnCdnFiles,
} from "@/utilities/ImageGallery";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";

export default {
  name: "createInstallabilityIcons",

  components: { PicSelector },

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "create-install-ability-icons",
    files: {
      icon: null,
      iconLoading: false,
      screenshot: null,
      screenLoading: false,
    },
    loading: false,
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    readerRead(file, slot = "logo") {
      if (file) {
        const reader = new FileReader();
        const _this = this;

        reader.onload = function (e) {
          const img = new Image();
          img.onload = function () {
            switch (slot) {
              case "logo":
                _this.inputChange(img);
                break;
              case "screenshot":
                _this.screenInputChange(img);
                break;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    inputChange(img) {
      // Draw image on 144px canvas with "object-fit: cover"
      const canvas144 = document.getElementById("canvas144");
      drawImageOnCanvasCover(canvas144, img, 144, 144);

      // Draw image on 48px canvas with "object-fit: cover"
      const canvas48 = document.getElementById("canvas48");
      drawImageOnCanvasCover(canvas48, img, 48, 48);

      // Upload canvas images to the server
      this.uploadCanvasImage(canvas48, "48px_image.png", "icon48");
      this.uploadCanvasImage(canvas144, "144px_image.png", "icon144");
    },
    screenInputChange(img) {
      // Draw image on 144px canvas with "object-fit: cover"
      const canvas144 = document.getElementById("screenshotWide");
      drawImageOnCanvasCover(canvas144, img, 1280, 720);

      // Draw image on 48px canvas with "object-fit: cover"
      const canvas48 = document.getElementById("screenshot600");
      drawImageOnCanvasCover(canvas48, img, 600, 400);

      // Upload canvas images to the server
      this.uploadCanvasImage(canvas144, "144px_image.png", "screenshotWide");
      this.uploadCanvasImage(canvas48, "48px_image.png", "screenshot600");
    },
    // Function to upload canvas image to the server
    uploadCanvasImage(canvas, filename, field) {
      this.loading = true;

      // Convert canvas content to a data URL (PNG format)
      const imageDataUrl = canvas.toDataURL("image/png");

      // Example Base64 string and mimeType
      const base64String = imageDataUrl.replace("data:image/png;base64,", "");
      const mimeType = "application/octet-stream"; // Adjust the MIME type as needed

      // Convert Base64 to Blob
      const fileBlob = base64ToBlob(base64String, mimeType);

      saveOnCdnFiles(
        fileBlob,
        filename.replace(/ /g, "_"),
        "تصاویر وب اپلیکیشن",
      )
        .then(({ data }) => {
          this.$toast.success("تصاویر با موفقیت اپلود شد ");
          this.computedValue[field] = data.data.link;
          // this.files.icon = null
          // this.files.screenshot = null
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
canvas {
  max-width: 200px;
}
</style>
